import { JustificativaModal } from '@components/Modal/JustificativaModal';
import { IForm } from '@hooks/useForm';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IJustificativaRequest } from '@hooks/useRequest';
import IFatura from '@model/Fatura';
import { useFaturaService } from '@services/FaturaService';
import { AxiosResponse } from 'axios';
import React from 'react';

export type FaturaDesfazerCancelamentoModalProps = {
    modal: IModalWindow
    fatura: IFatura
    onFaturaCancelamentoDesfeito: (response: AxiosResponse<IFatura>) => void
}

export function FaturaDesfazerCancelamentoModal ({ modal, fatura, onFaturaCancelamentoDesfeito }: FaturaDesfazerCancelamentoModalProps) {
    const loading = useLoading();
    const message = useMessage();

    const faturaService = useFaturaService();

    const handleConfirm = React.useCallback((values: IJustificativaRequest, form: IForm<IJustificativaRequest>)  => {
        if (!loading.isLoading) {
            loading.start();
            faturaService.desfazerCancelamento(fatura.faturaId, values)
                .then(response => {
                    message.success("Cancelamento da fatura desfeito com sucesso");
                    modal.close();
                    onFaturaCancelamentoDesfeito(response);
                })
                .catch(e => {
                    message.handleResponse(e)
                        .badRequest(form.setErrorsFromServer)
                        .showException();
                })
                .finally(loading.stop);
        }
    }, [fatura.faturaId, faturaService, loading, message, modal, onFaturaCancelamentoDesfeito]);

    return (
        <JustificativaModal 
            confirmText="Desfazer Cancelamento"
            disabled={loading.isLoading}
            modal={modal}
            onConfirm={handleConfirm}
            title={`Desfazer Cancelamento da Fatura ${fatura.faturaId}`}
        />
    )
}